import React from 'react';

import iso1401 from "../images/logos/iso14001.svg";
import iso27001 from "../images/logos/iso27001.svg";
import enisa from "../images/logos/enisa.svg";
import ripe from "../images/logos/ripe.svg";
import eidas from "../images/logos/eidas-trusted-list.svg";
import certeidas from "../images/logos/certeidas.svg";
import ens from "../images/logos/ens.svg";
import rsa from "../images/logos/rsa-pyme.svg";

const Footer = () => {
    return (
        <footer className="c-footer u-wrapper t-padding-top:120">
            <nav className="c-footer__sobre-coloriuris t-padding-bottom:20">
                <h3 className="c-h3 u-title-line u-title-line--grey">Sobre Coloriuris</h3>
                <ul className="t-list-style:none t-padding-left:0 t-margin-top:40">
                    <li><a className="t-color:color-grey-200 t-text-decoration:none" href="https://www.coloriuris.net/blog/">Blog</a></li>
                    <li><a className="t-color:color-grey-200 t-text-decoration:none" href="https://www.coloriuris.net/es:avisos_legales">Aviso legal</a></li>
                    <li><a className="t-color:color-grey-200 t-text-decoration:none" href="https://www.coloriuris.net/es:politica_privacidad">Política de privacidad</a></li>
                    <li><a className="t-color:color-grey-200 t-text-decoration:none" href="https://www.coloriuris.net/es:politica_cookies">Política de cookies</a></li>
                    <li><a className="t-color:color-grey-200 t-text-decoration:none" href="https://cipsc.coloriuris.net">Timestamping cualificado</a></li>
                    <li><a className="t-color:color-grey-200 t-text-decoration:none" href="https://www.coloriuris.net/es:convenios">Convenios</a></li>
                    <li><a className="t-color:color-grey-200 t-text-decoration:none" href="https://www.coloriuris.net/estatico/feder/">FEDER</a></li>
                    <li><a className="t-color:color-grey-200 t-text-decoration:none" href="https://www.coloriuris.net/estatico/idis-react-22/">IDIS REACT 22</a></li>
                </ul>
            </nav>
            <nav className="c-footer__contactar t-padding-bottom:20">
                <h3 className="c-h3 u-title-line u-title-line--grey">Contactar</h3>
                <ul className="t-list-style:none t-padding-left:0 t-margin-top:40">
                    <li><a className="t-color:color-grey-200 t-text-decoration:none" href="https://www.coloriuris.net/es:contactar">Contacto</a></li>
                    <li><a className="t-color:color-grey-200 t-text-decoration:none" href="https://www.coloriuris.net/es:oficinas">Oficinas</a></li>
                    <li><a className="t-color:color-grey-200 t-text-decoration:none" href="tel:+34976203670">+34 976 203 670</a></li>
                    <li><a className="t-color:color-grey-200 t-text-decoration:none" href="mailto:info@coloriuris.net">info@coloriuris.net</a></li>
                    <li><a className="t-color:color-grey-200 t-text-decoration:none" href="https://www.linkedin.com/company/coloriuris-a-i-e-">Coloriuris en Linkedin</a></li>
                </ul>
            </nav>
            <ul className="c-footer__logos t-list-style:none t-padding-left:0 t-padding-bottom:80">
                <li><img src={rsa} alt="" width={100} height={100}/></li>
                <li><img src={ens} alt="" width={100} height={100}/></li>
                <li><img src={certeidas} alt="" width={100} height={100}/></li>
                <li><img src={eidas} alt="" width={100} height={100} /></li>
                <li><img src={ripe} alt="" width={100} height={100}/></li>
                <li><img src={enisa} alt="" width={100} height={100}/></li>
                <li><img src={iso27001} alt="" width={100} height={100}/></li>
                <li><img src={iso1401} alt="" width={100} height={100}/></li>
            </ul>
            <p className="c-footer__legal u-grid-expand-all t-max-width:100% u-border-top t-border-color:color-grey-800 t-padding-top:10 t-font-size:s t-text-align:center">
                Coloriuris S.L. — B-99.091.696 — C/ Alfonso I, no 23, Zaragoza — Inscrita en el R.M. de Zaragoza T-3330, L-0, F-107, H-Z40193<br/>
                <a className="t-color:color-grey-200 t-text-decoration:underline" href="http://ec.europa.eu/consumers/odr/">Resolución de litigios en línea</a>
            </p>
            <p className="c-footer__coloriuris-contract u-grid-expand-all t-text-align:center t-max-width:100% "></p>
        </footer>
    );
}

export default Footer;
